import React from 'react'
import { useLocation } from 'react-router-dom'
import { MonitoreoYEvaluacionFormView } from './MonitoreoYEvaluacion'
import { MonitoringAndEvaluationProvider } from '../../../../context/MonitoringAndEvaluationContext'
import { MonitoreoContextProvider } from '../../../../context/MonitoreoContext'

const FormMonitoreoEvaluacionView = () => {
  const location = useLocation()
  return (
    <MonitoringAndEvaluationProvider>
      <MonitoreoContextProvider>
        <MonitoreoYEvaluacionFormView idForm={location.state} />
      </MonitoreoContextProvider>
    </MonitoringAndEvaluationProvider>
  )
}

export default FormMonitoreoEvaluacionView
